import styled from 'styled-components';

export const Card = styled.div`
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  padding: 1.8rem;
  margin-bottom: 1.8rem;
  width: 100%;
`;